import { log } from "missionlog";
import { Moment } from "moment";
import * as React from "react";
import { FunctionComponent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { urlHistoryGetParaHistoryTasks, WORDITEMTYPE } from "../../../../api/apilinks";
import { httpGetAuth, HttpResponse } from "../../../../api/httpAPI";
import { limaLogTag } from "../../../../limaCommon/limaLog";
// import { highlightTaskLinks3, HIGHLIGHT_TYPE } from "../../../../limaCommon/limaWordInteract";
import { LimaLoadingComponnet } from "../../../../limaComponents/LimaLoadingComponnet";
import { LimaNotice } from "../../../../limaComponents/LimaNotice";
import limaLoadeStore from "../../../../store/limaLoaderStore";
import limaStore from "../../../../store/limaStore";
import { User2Task_withActaXcopyParasCommentsTasksMessagesAttachements } from "../../../../types/User2Task_withActaXcopy";
import { SelectedInWord } from "../../../../types/wordObjects";
import { E_TASKPARAMS } from "../../Tasks/components/TaskListItemV4";
import TasksListV4 from "../../Tasks/TaskListV4";
// import HistParaItemParaTaskRowV4 from "./2DL_HistParaItemParaTaskRowV4";

type IHistParaItemTaskItemsV4Props = {
  dateFrom: Moment;
  dateTo: Moment;
  selectedItem: SelectedInWord;
};
/**
 * Show tasks linked to Para
 * !!! we dont have .task in response for User2Task_withActaXcopy[] use task_withActaXcopy
 *
 */

const HistParaItemTaskItemsV4: FunctionComponent<IHistParaItemTaskItemsV4Props> = ({
  dateFrom,
  dateTo,
  selectedItem,
}: IHistParaItemTaskItemsV4Props) => {
  const { t } = useTranslation(["tpshow"]);
  const [parHistTasks, setParHistTasks] = useState<User2Task_withActaXcopyParasCommentsTasksMessagesAttachements[]>();

  const { isLoading, isFetching, error, refetch } = useQuery<
    User2Task_withActaXcopyParasCommentsTasksMessagesAttachements[],
    Error
  >(
    [
      "tasksForPara",
      {
        itemid: (selectedItem && selectedItem.id) || null,
        itemtype: (selectedItem && selectedItem.type) || null,
        userid: limaStore.userId || null,
        datefrom: (dateFrom && dateFrom.toISOString()) || null,
        dateto: (dateTo && dateTo.toISOString()) || null,
      },
    ],
    () =>
      getTasksForPara(
        (selectedItem && selectedItem.id) || null,
        (selectedItem && selectedItem.type) || null,
        // limaStore.userId || null,
        (dateFrom && dateFrom.toISOString()) || null,
        (dateTo && dateTo.toISOString()) || null
      ),
    {
      refetchOnWindowFocus: false,
      enabled: false,
      onError: (err) => {
        log.error(limaLogTag.HistParaItemParaTaskItems, "useQuery get attachements ", err);
      },
      onSuccess: (data: User2Task_withActaXcopyParasCommentsTasksMessagesAttachements[]) => {
        log.info(limaLogTag.HistParaItemParaTaskItems, "useQuery success ", data);
        setParHistTasks(data);
      },
    }
  );

  useEffect(() => {
    log.info(limaLogTag.HistParaItemParaTaskItems, "UEF: start");
    // queryFinish && setQueryFinish(false);
    void refetch();
  }, [dateFrom, dateTo, selectedItem]);

  if (isLoading || isFetching) {
    log.info(limaLogTag.HistParaItemParaTaskItems, "searching for Tasks");
    // return <LimaHideableSection name={`${t("tpshow:history.tasksLbl")}`}>{LimaLoadingComponnet()}</LimaHideableSection>;
    return <>{LimaLoadingComponnet()}</>;
  }
  if (error) {
    return (
      // <LimaHideableSection name={`${t("tpshow:history.tasksLbl")}`}>
      <LimaNotice>{t("tpshow:history.errorloadingLbl")}</LimaNotice>
      // </LimaHideableSection>
    );
  }

  // let sectionName = `${t("tpshow:history.tasksLbl")} `;
  // if (parHistTasks && parHistTasks.length > 0) sectionName += `[${parHistTasks.length}]`;
  //`${t("tpshow:history.tasksLbl")} [${parHistTasks && parHistTasks.length}]`

  return (
    // <LimaHideableSection name={sectionName}>
    //   {parHistTasks && parHistTasks.length > 0 ? (
    //     <Toggle
    //       label={t("tpshow:history.tasks.highlightLbl")}
    //       inlineLabel
    //       checked={showHighLight}
    //       onClick={() => {
    //         setShowHighLight(!showHighLight);
    //       }}
    //     />
    //   ) : (
    //     <></>
    //   )}
    //   {parHistTasks &&
    //     parHistTasks.map(
    //       (paraHistoryItem: User2Task_withActaXcopyParasCommentsTasksMessagesAttachements, index: number) => (
    //         <HistParaItemParaTaskRowV4
    //           key={paraHistoryItem._key}
    //           itemKey={paraHistoryItem._key}
    //           index={index}
    //           showHighlight={showHighLight}
    //           paraHistoryTaskRow={paraHistoryItem.task_withActaXcopyParasCommentsTasksMessagesAttachements}
    //         />
    //       )
    //     )}
    // </LimaHideableSection>
    <>
      <TasksListV4
        includeHidable={true}
        definedTasksList={parHistTasks}
        // onMouseEnterTask={onMouseEnterTask}
        // onMouseLeaveTask={onMouseLeaveTask}
        hideTaskParams={[E_TASKPARAMS.CREATEDATE, E_TASKPARAMS.DUEDATE, E_TASKPARAMS.DESCRIPTION]}
        addEnabled={false}
        showFilters={false}
        showSearch={false}
        highlighTaskMouseOverAlwaysOn={true}
        enableHighlight={false}
      />
    </>
  );
};
export default HistParaItemTaskItemsV4;

//----------------------
//   REACT QUERY
//----------------------

async function getTasksForPara(
  itemid: string,
  _itemtype: WORDITEMTYPE,
  // userid: string,
  datefrom: string,
  dateto: string
) {
  // const [, { itemid, userid, datefrom, dateto }] = params.queryKey;

  if (itemid === null) {
    log.info(limaLogTag.HistParaItemParaText, "getTasksForPara: itemid is null");
    return null;
  }
  if (datefrom === null || dateto === null) {
    log.info(limaLogTag.HistParaItemParaText, "getTasksForPara: datefrom is null or dateto is null");
    return null;
  }
  const loaderID = limaLoadeStore.add("Getting getTasksForPara from DB");
  let response: HttpResponse<User2Task_withActaXcopyParasCommentsTasksMessagesAttachements[]>;
  try {
    response = await httpGetAuth<User2Task_withActaXcopyParasCommentsTasksMessagesAttachements[]>(
      urlHistoryGetParaHistoryTasks(itemid, true, true),
      loaderID.ac
    );
    log.info(limaLogTag.HistParaItemParaText, "getTasksForPara: asketo to get something", response);
    if (response.parsedBody !== undefined) {
      log.info(limaLogTag.HistParaItemParaText, "getTasksForPara: parsedBody is not null", response.parsedBody);
      //   const userListCopies = response.parsedBody;
      return response.parsedBody;
    } else {
      log.error(limaLogTag.HistParaItemParaText, "getTasksForPara Error no data", response);
      // throw new Error("...No data...");
      return null;
    }
  } catch (response) {
    log.error(limaLogTag.HistParaItemParaText, "getTasksForPara Error call get data", response);
    // throw new Error("Problem geting data");
    return null;
  } finally {
    //this.setLoadingData(false);
    limaLoadeStore.remove(loaderID.k);
  }
}
